var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"itaku"}},[_c('header',[_c('Head')],1),_c('body',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }